import { SectionNameTypes } from '@assets/model/ScoreUtils';
import * as svgs_png from './*.png';
import * as svgs from './*.svg';
import { string } from 'zod';
interface SectionIconProps {
    section: SectionNameTypes;
    className?: string;
}

var base64_lookup: { [key: string]: string } = {};

export const GetSectionIconUrl = (section: SectionNameTypes): string => {
    if (!svgs[section]) {
        return null;
    }
    return svgs[section];
};

async function urlToBase64(url) {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string); // base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
var base64_lookup: { [key: string]: string } = {};
const fetch_base64 = async () => {
    for (const key of Object.keys(svgs_png)) {
        base64_lookup[key] = await urlToBase64(svgs_png[key]);
    }
};

fetch_base64();

export const GetSectionIconUrlBase64 = (section: SectionNameTypes): string => {
    if (!base64_lookup[section]) {
        return null;
    }
    return base64_lookup[section];
};

export const SectionIcon = (p: SectionIconProps) => {
    return (
        <div className={p.className}>
            <img src={svgs_png[p.section]} />
        </div>
    );
};
